import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from './LegalPageLayout';

export default function ShippingPage() {
  return (
    <LegalPageLayout
      title="Shipping & Delivery"
      subtitle="Information regarding the shipping of your custom tailored garments."
      lastUpdated="August 30, 2024"
      activePath="/shipping"
    >
      <p>
        For International buyers, orders are shipped and delivered through registered international
        courier companies and/or International speed post only.
      </p>
      <p>
        For domestic buyers, orders are shipped through registered domestic courier companies and/or
        speed post only.
      </p>
      <p>
        Orders are shipped within <strong>8-14 days</strong> or as per the delivery date agreed at
        the time of order confirmation and delivering of the shipment subject to Courier Company /
        post office norms.
      </p>
      <p>
        Blue Pearl is not liable for any delay in delivery by the courier company / postal
        authorities and only guarantees to hand over the consignment to the courier company or
        postal authorities within 8-14 days from the date of the order and payment or as per the
        delivery date agreed at the time of order confirmation.
      </p>
      <p>
        Delivery of all orders will be to the address provided by the buyer. Delivery of our
        services will be confirmed on your mail ID as specified during registration.
      </p>

      <div className="legal-other-policies">
        <h3>Related Policies</h3>
        <div className="legal-other-policies-grid">
          <Link to="/terms" className="legal-policy-chip">Terms & Conditions</Link>
          <Link to="/privacy" className="legal-policy-chip">Privacy Policy</Link>
          <Link to="/cancellation" className="legal-policy-chip">Cancellation Policy</Link>
          <Link to="/returns" className="legal-policy-chip">Return & Refund Policy</Link>
        </div>
      </div>
    </LegalPageLayout>
  );
}
